import { useEffect } from 'react';

/**
 * General function for handling on post message messages
 */
export function usePostMessageHandler<T = any>(
  onPostMessage: (event: MessageEvent<T>) => void
) {
  useEffect(() => {
    window.addEventListener<'message'>('message', onPostMessage);
    return () => window.removeEventListener('message', onPostMessage);
  });
}
